export const PERMISSION = { USERS_UPDATE: 'Users.Update' };

// Mirrors admin-corev2's permissionMiddleware: case-insensitive match on the
// user's role[].permission[].id, read from the sessionStorage `user` (written at
// login/renew — the /profile response does not carry role/permission).
export function hasPermission(scope) {
	try {
		const userStr = sessionStorage.getItem('user');
		if (!userStr) return false;
		const roles = JSON.parse(userStr)?.role || [];
		return roles.some((r) =>
			(r.permission || []).some((p) => p?.id?.toLowerCase() === scope.toLowerCase())
		);
	} catch {
		return false;
	}
}

export const hasUsersUpdatePermission = () => hasPermission(PERMISSION.USERS_UPDATE);
